import React from "react";
import { CButton } from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilTask } from "@coreui/icons";
import { useHistory } from "react-router-dom";

const AppHeaderAbsensi = () => {
  const history = useHistory();

  return (
    <div className="d-flex align-items-center w-100 w-md-auto" style={{ height: '38px' }}>
      <CButton 
        color="primary" 
        className="d-flex justify-content-center justify-content-md-start align-items-center shadow-sm h-100 w-100 w-md-auto text-white"
        style={{ borderRadius: '4px', padding: '0 12px', fontWeight: '500', transition: 'all 0.3s', border: 'none' }}
        onClick={() => history.push('/hr/attendance')}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
          e.currentTarget.style.filter = "brightness(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.05)";
          e.currentTarget.style.filter = "brightness(1)";
        }}
      >
        <div className="bg-white bg-opacity-25 rounded d-flex align-items-center justify-content-center me-2" style={{ width: '24px', height: '24px' }}>
          <CIcon icon={cilTask} size="sm" />
        </div>
        <span className="fw-semibold">Absensi</span>
      </CButton>
    </div>
  );
};

export default AppHeaderAbsensi;
